import environment from "@/constants/Environment";

class ConsoleController {
  originalMethods: { [key: string]: Function };
  isDisabled: boolean;

  constructor() {
    this.originalMethods = {};
    this.isDisabled = false;
  }

  storeOriginalMethods() {
    this.originalMethods = {
      log: console.log,
      warn: console.warn,
      error: console.error,
      info: console.info,
      debug: console.debug,
      trace: console.trace,
      table: console.table,
      group: console.group,
      groupEnd: console.groupEnd,
      time: console.time,
      timeEnd: console.timeEnd,
    };
  }

  disable() {
    if (!this.isDisabled) {
      this.storeOriginalMethods();

      console.log = () => {};
      console.warn = () => {};
      console.info = () => {};
      console.debug = () => {};
      console.trace = () => {};
      console.table = () => {};
      console.group = () => {};
      console.groupEnd = () => {};
      console.time = () => {};
      console.timeEnd = () => {};

      // console.error = () => {}; keeping error logs always enabled

      this.isDisabled = true;
    }
  }

  enable() {
    if (this.isDisabled && this.originalMethods.log) {
      Object.keys(this.originalMethods).forEach((method) => {
        console[method] = this.originalMethods[method];
      });

      this.isDisabled = false;
    }
  }

  checkAndToggle() {
    const urlParams = new URLSearchParams(window.location.search);
    const debugMode = urlParams.get("debug") === "true";
    const currentEnvironment = environment().ENVIRONMENT;
    const isStagingOrDev =
      currentEnvironment === "staging" || currentEnvironment === "development";

    if (debugMode || isStagingOrDev) {
      this.enable();

      const modeMessage = isStagingOrDev
        ? debugMode
          ? "D🐛 | 🧑‍💻"
          : "🧑‍💻"
        : debugMode
          ? "D🐛"
          : "";
      console.log(`${modeMessage} mode enabled - Console logs are active`);
    } else {
      this.disable();
    }
  }

  toggle() {
    if (this.isDisabled) {
      this.enable();
    } else {
      this.disable();
    }
  }
}

const consoleController = new ConsoleController();
export default consoleController;
